import { render, staticRenderFns } from "./AbkSurveysBox.vue?vue&type=template&id=17c3b533&scoped=true&"
import script from "./AbkSurveysBox.vue?vue&type=script&lang=js&"
export * from "./AbkSurveysBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveysBox.vue?vue&type=style&index=0&id=17c3b533&scoped=true&lang=scss&"
import style1 from "./AbkSurveysBox.vue?vue&type=style&index=1&id=17c3b533&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c3b533",
  null
  
)

export default component.exports